export default __webpack_public_path__ + "static/media/SurveyManagement.13e8dcd6.svg";